
{
  "fr": {
    "zoneInputText": {
      "label": "Ajouter un texte",
      "placeholder": "@:zoneInputText.label"
    }
  }
}
